import React from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { format } from "date-fns";

interface DailySearch {
  date: string;
  search_count: number;
}

interface Props {
  data: DailySearch[];
}

export default function DailySearchesHeatmap({ data }: Props) {
  if (!data || data.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-muted-foreground">
        No search activity data available
      </div>
    );
  }

  const formattedData = data.map((item) => ({
    ...item,
    dateFormatted: format(new Date(item.date), "MMM d"),
  }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart data={formattedData}>
        <defs>
          <linearGradient id="searchGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(var(--primary))" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="hsl(var(--primary))" stopOpacity={0.1}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis 
          dataKey="dateFormatted" 
          className="text-xs"
          angle={-45}
          textAnchor="end"
          height={80}
        />
        <YAxis className="text-xs" />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: "hsl(var(--background))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "8px"
          }}
          labelFormatter={(value) => `Date: ${value}`}
        />
        <Area 
          type="monotone" 
          dataKey="search_count" 
          stroke="hsl(var(--primary))" 
          fill="url(#searchGradient)"
          strokeWidth={2}
          name="Searches"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
